export default {
    activity: 'Loading Data...',
    addToMyAnalogModalDesc: '将产品添加到myAnalog 的现有项目或新项目中（接收通知）。',
    addToMyAnalogModalDescTable: '在 myAnalog 参数搜索中添加模块， 可以添加到现有项目或新项目中。',
    addToMyAnalogDropdownTitle: '添加产品至',
    addToMyAnalogDropdownTitleTable: '添加所有模块',
    myAnalogProjectProduct: 'myAnalog 中收藏的产品',
    myAnalogProjectTable: '在 myAnalog 中进行参数搜索',
    myAnalogNewProject: '新项目',
    createNewProject: '创建新项目',
    projectName: '产品名称',
    projectNameTakenError: '这个项目名称已存在。请另起一个新名称。',
    receivePcnPdnNotifications: '接收所有 PCN/PDN 的产品型号通知',
    projectDescription: '描述',
    tableName: '表格名称',
    note: '注释',
    button: {
        and: 'AND',
        blanks: 'Blanks',
        cancel: '取消',
        confirm: '确认',
        compare: 'Compare',
        default: '默认',
        deselectAll: '全部取消',        
        downloadToExcel: '下载到 Excel', //download_to_excel
        feedBack: '发送反馈',
        filters: {
            minimize: '最小化筛选器',
            maximize: '最大值滤波器',
            hide: '隐藏过滤器',
            show: '显示过滤器',
            reset: '重启'
        },
        hide: 'HIDE',
        last: 'Last',
        next: 'Next',
        ok: 'OK',
        or: 'OR',
        parameters: {
            choose: '选择参数',
            all: '全部选择'
        },
        previous: 'Previous',
        quickTips: 'Quick Tips',
        reset: '重置表格',
        save: '保存至 myAnalog',
        selectAll: '全部选择',
        share: '分享',
        showAll: 'Show All',
        sortByNewest: '按最新排序',
        toggleDescription: 'Toggle Description Column',
        toggleHardware: 'Toggle Hardware Column',
        toggleStatus: 'Toggle Status Column',
        toggleTools: 'Toggle Tools Column',
        copyLink: '复制链接',
        copied: '已复制',
        viewParts: '查看 {count} 个零件',
        addedToMyAnalog: '添加至 myAnalog',
        addToMyAnalog: '添加至 myAnalog',
        addToMyCart: '添加至我的购物车',
        viewDataSheet: '查看数据手册',
        dragAndDrop: '拖拽',
        hideColumn: '隐藏',
        sort: '排序',
        sortAsc: '升序排序',
        sortDesc: '降序排序'
    },
    excel: {
        columnName: 'Column Name',
        cover: 'Cover',
        dateCreated: 'Date Created',
        display: {
            raw: 'Raw Data Display',
            web: 'Web Display'
        },
        filename: 'ADI参数搜索', //download_excel_file_name
        filter: {
            conditions: 'Filter Conditions',
            values: 'Filter Values',
            none: 'None'
        },        
        productType: 'Product Type',
        webLink: 'Web Link'
    },
    footnote: {
        pricing: {
            disclosure: '* 此处所列报价仅供预算参考，指美元建议报价（规定订量的单价，美国离岸价）。',
            evaluationBoardsAndKits: '对于评估板和套件的报价是指1个单位价格。',
            unavailable: '** 目前不提供具体报价。有关更多信息，请点击产品型号，查看产品页面。'
        }
    },
    filterParts: 'Filter Parts',
    checkDistributorInventory: 'Check Distributor Inventory',
    inputs: {
        defaultPlaceholder: 'Filter {name}'
    },
    link: {
        downloadDataSheet: '下载数据手册',
        viewDataSheet: '查看数据手册',
        sampleAndBuy: '样片申请及购买',
        viewDocumentation: 'View Documentation'
    },
    new: 'NEW',
    noResults: '无搜索结果',
    pageReq: 'You cannot enter a value greater or less than the number of available pages.',
    partNumber: '产品型号',
    parts: '器件',
    tooltip: {
        referenceCircuit: '可用参考电路', //cftl_tooltip
        evaluationBoard: '评估板'
    },
    totalPages: '/ {total}',
    valuesSelected: '选定值', //checkbox_filter_min_value
    selectOneOrMore: '选择一个或多个选项',
    recommendedNewDesigns: '推荐用于新设计',
    items: '项',
    resultPerPage: '页',
    page: '页',
    of: '/'
};